import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  formatDateWithDayjs,
  showToast,
  formatCurrencyAmount
} from "../../../../utils/utils";
import {
  CURRENCY_FORMAT,
  DD_MMM_YYYY,
  DUEDATE,
  INVOICEDATE,
  TOTALAMOUNT,
  showToastType
} from "../../../../utils/constants/appConstants";
import { getInvoiceCommentsURL } from "../../../../utils/constants/apiEndPoints";
import privateAxios from "../../../../utils/axiosPrivate";
import { sanitizeInput } from "../../../../utils/utils";
import { Inputfieldvalidation } from "../../../../locales/en";

const CommentCell = ({ value, row }) => {
  const [comment, setComment] = useState(value || "");
  const initialInvoiceError = {
    comment: null
  };
  const [invoiceError, setInvoiceError] = useState(initialInvoiceError);

  const handleInvoiceError = (name, value) => {
    let error = "";
    if (name === "comment") {
      if (value.length > 50) {
        error = Inputfieldvalidation.errorMsg.commentMaxLength;
      }
    }
    setInvoiceError((prev) => ({ ...prev, [name]: error }));

    return error;
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setComment(newValue);
    handleInvoiceError(Inputfieldvalidation.errorMsg.comment, newValue);
  };

  const handleBlur = async () => {
    const error = handleInvoiceError(
      Inputfieldvalidation.errorMsg.comment,
      comment
    );
    if (error) return;

    try {
      const sanitizedComment = sanitizeInput(comment.trim());
      const datatoSend = { comment: sanitizedComment };
      const response = await privateAxios.post(
        getInvoiceCommentsURL(row.original.id),
        datatoSend
      );

      if (response.status === 200) {
        setComment(sanitizedComment);
        showToast(response.data.message, showToastType.success);
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || showToastType.errorText,
        showToastType.error
      );
    }
  };

  return (
    <>
      <textarea
        name="comment"
        value={comment}
        onChange={handleChange}
        onBlur={handleBlur}
        className="w-100"
      />
      {invoiceError.comment && (
        <span className="text-danger font-12">{invoiceError.comment}</span>
      )}
    </>
  );
};

CommentCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
  }).isRequired
};

export const COLUMNS = [
  {
    Header: "Invoice Number",
    Footer: "Invoice Number",
    accessor: "invoiceNumber"
  },
  {
    Header: "Customer",
    Footer: "Customer",
    accessor: "debatorName"
  },
  {
    Header: "Invoice Total",
    Footer: "Invoice Total",
    accessor: TOTALAMOUNT,
    Cell: ({ value }) => {
      return formatCurrencyAmount(value, CURRENCY_FORMAT);
    }
  },
  {
    // The future-date rule greys a row out on this value, so it has to be
    // visible for a customer or staff member to see what is being compared.
    Header: "Invoice Date",
    Footer: "Invoice Date",
    accessor: INVOICEDATE,
    Cell: ({ value }) => {
      return value ? formatDateWithDayjs(value, DD_MMM_YYYY) : "";
    }
  },
  {
    Header: "Due Date",
    Footer: "Due Date",
    accessor: DUEDATE,
    Cell: ({ value, row }) => {
      const displayDate = row.original?.repaymentDate || value;
      if (displayDate) {
        return formatDateWithDayjs(displayDate, DD_MMM_YYYY);
      } else {
        return "";
      }
    }
  },
  {
    Header: "Comments",
    Footer: "Comments",
    accessor: "comment",
    Cell: CommentCell
  }
];
